import { render, staticRenderFns } from "./dependentsPopup.vue?vue&type=template&id=727a53b0&scoped=true"
import script from "./dependentsPopup.vue?vue&type=script&lang=js"
export * from "./dependentsPopup.vue?vue&type=script&lang=js"
import style0 from "./dependentsPopup.vue?vue&type=style&index=0&id=727a53b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727a53b0",
  null
  
)

export default component.exports